// ─── where this client points ────────────────────────────────────────────────
// The data plane is the voicebox service itself. The control plane is a *broker*
// that holds the API key a browser must never hold:
//   · dev  — `wrangler dev` on :8787 with DEV_OPEN=true, so no key is needed
//   · prod — the same-origin Pages Function in `functions/v1/sessions.ts`
// Query overrides exist so the Playwright harnesses can point the app at an
// ephemeral server without a rebuild.

const query = new URLSearchParams(location.search)

export const API_BASE = (
  query.get('api') ??
  import.meta.env.VITE_VOICEBOX_API ??
  (import.meta.env.DEV ? 'http://127.0.0.1:8787' : 'https://voicebox-api.kiasubot.com')
).replace(/\/$/, '')

export const SESSION_URL =
  query.get('session') ?? import.meta.env.VITE_SESSION_URL ?? (import.meta.env.DEV ? `${API_BASE}/v1/sessions` : '/v1/sessions')

export const PROVIDERS_URL = `${API_BASE}/v1/providers`

/** Overrides for the settings panel, so a harness can pin provider or face. */
export const OVERRIDES = {
  provider: query.get('provider') ?? undefined,
  placement: query.get('placement') ?? undefined,
  face: query.get('face') ?? undefined,
  turnTaking: query.get('turn') ?? undefined,
  /**
   * Declare the session's input rate instead of letting the provider's native format
   * decide. Only the harnesses use it — it is how "16 kHz provider" is exercised
   * without a DashScope key.
   */
  inputRate: Number(query.get('inputRate')) || undefined,
}

export const BUILD = import.meta.env.VITE_BUILD ?? 'dev'
